import { useAuthStore } from '@/stores/auth.store'
import type { NavigationGuardWithThis } from 'vue-router'

export const authGuard: NavigationGuardWithThis<undefined> = async (to) => {
  const auth = useAuthStore()
  const isOnboardingRoute = to.path.startsWith('/onboarding')

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return {
      name: 'login',
      query: to.fullPath !== '/' ? { redirect: to.fullPath } : undefined,
    }
  }

  if (auth.isAuthenticated && auth.user?.onboarding_status === 'complete' && isOnboardingRoute) {
    return { name: 'dashboard' }
  }

  if (auth.isAuthenticated && auth.user?.onboarding_status && auth.user.onboarding_status !== 'complete') {
    if (!isOnboardingRoute) {
      try {
        await auth.fetchMe()
      } catch {
        // Keep the existing in-memory user and route to onboarding below.
      }

      if (auth.user?.onboarding_status === 'complete') {
        return true
      }

      return { name: 'onboarding-landing' }
    }
    return true
  }

  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'dashboard' }
  }

  return true
}
